import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash/fp';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import RouteCollection from '@bd/bdcore-named-routes';
import { Slugify } from '@bd/bdcore-utilities';
import PageHelmet from '@bd/bdcore-pagehelmet';
import Header from '../../components/Header';
import InsideHeader from '../../components/InsideHeader';
import Footer from '../../components/Footer';
import LightBoxPhotoList from '../../components/LightBoxPhotoList';
import MenuGalleries from './MenuGalleries';
import FooterForm from '../../components/FooterForm';
import { colors, typography } from '../../styles';


const styles = css`
  .PhotoGallery_wrapper {
    margin:40px auto;
    text-align: center;
    @media (min-width: 992px) {
      margin:80px auto;
    }
  }
  .PhotoGallery_categoryTitle {
    color: white;
    font:700 18px/1 ${typography.SansSerif};
    padding:20px 30px;
    border:1px solid ${colors.color1};
    text-transform: uppercase;
    display: inline-block;
    margin-bottom: 24px;
    background: ${colors.color1};
    @media (min-width: 992px) {
      font:700 24px/1 ${typography.SansSerif};
    }
  }
`;

function PhotoGallery({ page, router }) {
  const route = RouteCollection.getRouteByPath(_.get('location.pathname', router));
  const gallerySlug = _.get('params.gallery', route);
  let activeGallery;
  let photos = [];

  if (gallerySlug) {
    activeGallery = _.getOr([], 'photos', page)
      .find(g => Slugify(_.getOr('', 'category', g)) === gallerySlug);
    photos = _.getOr([], 'images', activeGallery);
  } else {
    photos = _.flow(
      _.map('images'),
      _.flatten,
    )(_.getOr([], 'photos', page));
  }

  return (
    <div className={styles}>
      <PageHelmet page={page} />
      <Header />
      <InsideHeader h1={`${page.page_title[0].title}`} h1Pre={`${page.page_title[0].pretitle}`} leadText={`${page.lead_copy}`} />
      <MenuGalleries
        page={page}
      />
      <div className="container PhotoGallery_wrapper">
        <h1 className="text-center PhotoGallery_categoryTitle">
          {_.get('category', activeGallery) ? _.get('category', activeGallery) : 'All Photos'}
          {' '}
          <span className="PhotoGallery_categoryPostTitle">{activeGallery ? '' : ''}</span>
        </h1>
        <LightBoxPhotoList
          show={12}
          gallery={_.get('category', activeGallery)}
          photos={photos}
        />
      </div>
      <FooterForm />
      <Footer />
    </div>
  );
}

PhotoGallery.propTypes = {
  page: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
};

export default withData({
  page: 'photo_gallery',
  router: true,
})(PhotoGallery);



// WEBPACK FOOTER //
// ./src/pages/PhotoGallery/index.js